import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-waivethewait',
  templateUrl: './waivethewait.component.html',
  styleUrls: ['./waivethewait.component.scss']
})
export class WaivethewaitComponent implements OnInit {

  constructor() { }

  
  ngOnInit(): void {

  }

}
